import { FC } from "react";

import Box from "@mui/material/Box";
import BundledDocument from "./components/BundledDocument";
import SingleDocument from "./components/SingleDocument";

import { ICartLineItemDocumentsProperties } from "./CartLineItemDocuments.types";

const CartLineItemDocuments: FC<ICartLineItemDocumentsProperties> = ({ documentIds }) => {
  if (documentIds.length === 0) {
    return null;
  }

  if (documentIds.length === 1) {
    return <SingleDocument documentId={documentIds[0]} />;
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      {documentIds.map((documentId) => (
        <BundledDocument key={documentId} documentId={documentId} />
      ))}
    </Box>
  );
};

export default CartLineItemDocuments;
